define('core/collections/ChannelCollection',[
    'underscore',

    'core/collections/PaginatedCollection',
    'core/UniqueModel',
    'core/api',
    'core/models/Channel',
    'core/utils/objectExpander',
], function (
    _,

    PaginatedCollection,
    UniqueModel,
    api,
    Channel,
    objectExpander
) {
    'use strict';

    var ChannelCollection = PaginatedCollection.extend({
        url: api.getURL('channels/list'),

        model: UniqueModel.boundModel(Channel),

        initialize: function (_models, options) {
            PaginatedCollection.prototype.initialize.call(this, _models, options);
            options = options || {};
            this.listName = options.listName;
        },

        fetch: function (options) {
            options = options || {};

            if (this.listName)
                options.data = _.extend({ listName: this.listName }, options.data);

            return PaginatedCollection.prototype.fetch.call(this, options);
        },

        parse: function (response) {
            response = PaginatedCollection.prototype.parse.call(this, response);

            // Some endpoints use reference/objects mapping for channels, which are handled
            // differently.
            if (response.items) {
                return _.map(response.items, function (listedChannel) {
                    return objectExpander.buildChannel(response.objects, listedChannel.reference);
                });
            }

            return response;
        },
    });

    return ChannelCollection;
});

